
import React, { useState } from "react";
import {
  Table,
  Tabs,
  Button,
  Space,
  Dropdown,
  Layout,
  Grid,
  Checkbox,
} from "antd";
import { FilterOutlined, MoreOutlined } from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";

const { TabPane } = Tabs;
const { Content } = Layout;
const { useBreakpoint } = Grid;

const Servers = () => {
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const screens = useBreakpoint(); // 👈 responsive hook

  const data = [
    {
      key: "1",
      name: "ubuntu-16gb-nbg1-1",
      type: "CX43 | x86 | 160 GB | eu-central",
      ip: "116.203.207.76",
      location: "Nuremberg",
    },
    {
      key: "2",
      name: "ubuntu-16gb-nbg1-1",
      type: "CX43 | x86 | 160 GB | eu-central",
      ip: "116.203.207.76",
      location: "Nuremberg",
    },
  ];

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const menuItems = [
    { key: "1", label: "Power Off" },
    { key: "2", label: "Resize" },
    { key: "3", label: "Delete", danger: true },
  ];

  const columns = [
    {
      title: "",
      width: 50,
      render: () => <Checkbox />,
      responsive: ["md"], // hide on mobile
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: 500 }} onClick={() => navigate(`/servers/${record.key}`)}>{text}</div>
          <div style={{ fontSize: 12, color: "#888" }}>{record.type}</div>
        </div>
      ),
    },
    {
      title: "Public IP",
      dataIndex: "ip",
      responsive: ["sm"], // hide on xs
    },
    {
      title: "Location",
      dataIndex: "location",
      responsive: ["md"], // hide on small screens
    },
    {
      title: "",
      width: 40,
      render: () => (
        <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
          <MoreOutlined style={{ fontSize: 18, cursor: "pointer" }} />
        </Dropdown>
      ),
    },
  ];

  return (
    <Content style={{ padding: screens.xs ? 12 : 24 }}>
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12,
          marginBottom: 16,
        }}
      >
        <Tabs defaultActiveKey="1" size={screens.xs ? "small" : "middle"}>
          <TabPane tab="Servers" key="1" />
          <TabPane tab="Snapshots" key="2" />
          <TabPane tab="Backups" key="3" />
          <TabPane tab="Placement Groups" key="4" />
          <TabPane tab="Primary IPs" key="5" />
        </Tabs>

        <Space wrap>
          <Button icon={<FilterOutlined />} />
          <Link to="/addservers">
            <Button
              type="primary"
              style={{ background: "#4f57f6" }}
              size={screens.xs ? "small" : "middle"}
            >
              Add Server
            </Button>
          </Link>
        </Space>
      </div>

      {/* TABLE */}
      <Table
        columns={columns}
        dataSource={filteredData}
        pagination={false}
        bordered={false}
        scroll={{ x: screens.xs ? 600 : "100%" }} // 👈 mobile scroll
        rowClassName={() => "dark-row"}
      />
    </Content>
  );
};

export default Servers;
